import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useMediaQuery } from "_common/component/MediaQueryProvider";
import MobileAddBankForm from "./MobileBank/AddBankForm";
import DesktopAddBankForm from "./DesktopBank/AddBankForm";

const AddBankPage = observer(() => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  if (isMobile) return <MobileAddBankForm />;

  return <DesktopAddBankForm />;
});

export default AddBankPage;
